import { render, staticRenderFns } from "./SOVall4page.vue?vue&type=template&id=8be1f330&scoped=true"
import script from "./SOVall4page.vue?vue&type=script&lang=js"
export * from "./SOVall4page.vue?vue&type=script&lang=js"
import style0 from "./SOVall4page.vue?vue&type=style&index=0&id=8be1f330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1f330",
  null
  
)

export default component.exports